// @flow
import React, { Component } from "react";

import UserAuth from "../../global/containers/UserAuth";
import RedirectoLogin from "../views/RedirectoLogin";
import MyQuote from "../containers/quotes/MyQuote";

class Project extends Component<*> {
  render(): * {
    return (
      <UserAuth
        oneOfPrincipalList={["billing"]}
        unAuthChildren={<RedirectoLogin />}
      >
        <div className="app-main">
          <MyQuote match={this.props.match} />
        </div>
      </UserAuth>
    );
  }
}

export default Project;
